import { ReportsProvider } from './context';
import { ReportsPage } from './page';

export const Reports = () => (
  <ReportsProvider>
    <ReportsPage />
  </ReportsProvider>
);
